var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_bell_svg__a)",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.058 8.75c0-.89.167-1.77.494-2.592a6.765 6.765 0 0 1 1.413-2.195 6.458 6.458 0 0 1 2.114-1.461A6.245 6.245 0 0 1 11.569 2c3.563.028 6.413 3.113 6.413 6.835V9.5c0 3.358.675 5.306 1.269 6.371a.774.774 0 0 1 .004.751.737.737 0 0 1-.263.276.698.698 0 0 1-.36.102H4.407a.697.697 0 0 1-.36-.102.735.735 0 0 1-.263-.276.774.774 0 0 1 .004-.751c.595-1.065 1.27-3.014 1.27-6.371v-.75ZM8.64 17v.75c0 .796.303 1.559.844 2.121.54.563 1.272.879 2.036.879s1.496-.316 2.037-.879c.54-.562.843-1.325.843-2.121V17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_bell_svg__a",
    x: -2,
    y: -1,
    width: 27.04,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_13215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_27_13215",
    result: "shape"
  })))));
};
export default SvgIconBell;